export function runtimeEndpoints(hostname:string,defaults:{control:string;installer:string}) {
 const china=hostname==='cn.lexside.ai';
 return {china,control:china?'https://api.cn.lexside.ai':defaults.control.replace(/\/$/u,''),
  installer:china?'get.cn.lexside.ai':defaults.installer};
}
